import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PersonalAccidentsQuoterStoreService } from '@webapp/quoter/risks/personal-accidents/store/personal-accidents-quoter-store.service';
import { ResumeItemComponent } from '@webapp/core/ui/components/resume-item/resume-item.component';
import { IResumeItem } from '@webapp/quoter/interfaces/quoter.interface';

@Component({
  selector: 'app-personal-accidents-resume',
  imports: [ResumeItemComponent],
  providers: [DatePipe],
  templateUrl: './personal-accidents-resume.component.html',
  styleUrl: './personal-accidents-resume.component.scss',
})
export class PersonalAccidentsResumeComponent {
  private PersonalAccidentsStateService = inject(
    PersonalAccidentsQuoterStoreService
  );
  readonly PersonalAccidentsState =
    this.PersonalAccidentsStateService.state.asReadonly();
  datePipe = inject(DatePipe);
  items: IResumeItem[] = [
    {
      title: 'Actividad',
      text: this.PersonalAccidentsState().insurable.activity ?? '',
    },
    {
      title: 'Cantidad de vidas',
      text: this.PersonalAccidentsState().insurable.numberOfLifes.toString(),
    },

    {
      title: 'Desde',
      text: `${this.datePipe.transform(
        this.PersonalAccidentsState().insurable.startDate,
        'dd/MM/yyyy'
      )}`,
    },
    {
      title: 'Hasta',
      text: `${this.datePipe.transform(
        this.PersonalAccidentsState().insurable.endDate,
        'dd/MM/yyyy'
      )}`,
    },
  ];
}
